// @ts-check
import React, { Component } from "react"
import { Button } from "ui"
import { selectPageAction } from "../../attributes/items/actions/pageActions"
import AvailableActions from "../../actions/AvailableActions"
import { text } from "../../attributes/items/primitives"

// import { text, select, boolean } from "../../_Editor/Attributes/_Composed"

// import TextAttribute from "../../_Editor/Attributes/TextAttribute"
// import DictListAttribute from "../../_Editor/Attributes/DictListAttribute"
// import Attribute from "../../_Editor/Attributes/ElementAttribute"

/**
 * @augments {Component<BlockTypeProps, {datetime?: Date}>}
 */
export default class ButtonBlockType extends Component {
    render() {
        const Wrapper = this.props.Wrapper

        return (
            <AvailableActions>
                {actions => {
                    return (
                        <Wrapper {...this.props}>
                            {({ attrs, computedStyle, evaluateFormulas }) => (
                                <Button
                                    type={attrs.type}
                                    size="small"
                                    disabled={!attrs.action || attrs.disabled}
                                    round={attrs.round}
                                    icon={attrs.icon && evaluateFormulas(attrs.icon)}
                                    onClick={() =>
                                        // !this.props.context.editor.isEditing &&
                                        {
                                            if (
                                                !attrs.action &&
                                                (attrs.link.startsWith("http://") ||
                                                    attrs.link.startsWith("https://") ||
                                                    attrs.link.startsWith("mailto:"))
                                            ) {
                                                window.location = evaluateFormulas(attrs.link)
                                            }
                                            attrs.action && this.onClick(attrs.action, actions)
                                        }
                                    }
                                    style={{ ...computedStyle, width: "100%", height: "100%" }}
                                >
                                    {evaluateFormulas(attrs.buttonTitle)}
                                </Button>
                            )}
                        </Wrapper>
                    )
                }}
            </AvailableActions>
        )
    }

    onClick(actionId, availableActions) {
        const matching = (availableActions || []).filter(available => available.id === actionId)
        if (matching.length) {
            const action = matching[0].action
            console.log("Running from v1 Button")
            action()
        }
    }
}

ButtonBlockType.attributes = [
    text({ field: "buttonTitle", label: "Title" }),
    selectPageAction({ field: "action", label: "Action when pressed" }),
    text({ field: "link", label: "Redirect after action" }),
]

ButtonBlockType.behaviours = {}



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/ButtonBlock.js